/** @import Assignee from '@/classes/facturae/Assignee' */
/** @import PaymentMethod from '@/classes/facturae/PaymentMethod' */

export default class FactoringAssignmentData {
  /** @type {Assignee?} */ assignee = null
  /** @type {PaymentMethod?} */ paymentMethod = null
  /** @type {string?} */ assignmentClauses = null
}
